import "pfkl-vcollapse/vcollapse/vcollapse.min.js";
import { data } from "./sold-data";

jQuery(function ($) {
  if (!$("body").hasClass("sold-questionnaire-page")) {
    return;
  }
  console.log("SoLD Questionnaire ready");

  function getLetter(number) {
    const alphabet = "abcdefghijklmnopqrstuvwxyz";
    return alphabet[number];
  }

  function printQuestionnaire(elem) {
    const printArea = document.getElementById(elem);

    if (printArea) {
      const printWindow = window.open("", "PRINT", "height=800,width=800");
      printWindow.document.write(
        `<html>
          <head>
            <title>${document.title}</title>
            <link rel="stylesheet" href="/themes/custom/tema/dist/main.css" type="text/css">
          </head>
          <body>
        `
      );
      printWindow.document.write(document.getElementById(elem).innerHTML);
      printWindow.document.write(`</body>
      </html>`);

      var removeElements =
        printWindow.document.querySelectorAll(".removeOnPrint");
      for (var i = 0; i < removeElements.length; i++) {
        removeElements[i].style.display = "none";
      }

      printWindow.document.close(); // necessary for IE >= 10
      printWindow.focus(); // necessary for IE >= 10*/
      printWindow.print();

      // printWindow.close();
      // return true;
    }
  }

  $("#printQuestionnaireBtn").on("click", function () {
    //window.print();
    printQuestionnaire("bigQuestCont");
  });

  /**********************TEMPLATING**********************/
  data.localContext.map((item, index) => {
    const lcGroup = $(`#lc-${getLetter(index).toUpperCase()}`);
    lcGroup
      .find(".tab-content--inner")
      .prepend(
        `<div class="overArchingQuestion">Overarching Question: ${item.overArching}</div>`
      );

    // gets categories questions from Data Object
    const localCatQuestions = item.questions;
    // find the corresponding tab for each category
    const localCatTarget = lcGroup.find(".localContextQuestionsCont");

    // Populate questions
    localCatQuestions.map(function (q) {
      localCatTarget.append(
        `<div class="${q.subCat} questionItem">
          <label class="questionText" for="${q.subCat + q.QuestionID}">${
          q.QuestionID
        }. ${q.Question}</label>
          <input type="checkbox" class="qCheckbox ${
            q.subCat
          } question localQuestionnaireQuestion" id="${
          q.subCat + q.QuestionID
        }" value="${q.Question}" />
        </div>`
      );
    });
  });

  data.pillarsQuestions.map((item, index) => {
    //gets subsubCategories
    const pillarSubCat = item.subCat;
    const pillarSubSubCategories = item.subsubCategories;

    //gets subsubCategories target DOM Nodes
    const pillarSubSubCategoriesTarget = $(
      `#pillarSubSubCategories${index + 1}`
    );

    // Populate subcategories
    pillarSubSubCategories.map(function (s) {
      var subsubCatString = s.subsubCat.replace(/\./g, "");
      var sss = s.subsubCat;

      pillarSubSubCategoriesTarget.append(
        `<div class="pillarSubCatItem subCategoryItem vcollapse-questionnaire vcollapse-questionnaire-container">
          <div class="pillarssubCatBox subcategory-toggle-container">
            <button class="pillarsubCategoriesLink subcategory-toggle collapse-toggle vcollapse-toggle"
              data-target="#pillars${subsubCatString}">
              <div>${sss} ${s.subSubCategory}</div>
              <div class="overArchingQuestion">Overarching Question: ${s.overArching}</div>
            </button>
            <input type="checkbox" class="pillarsSubCat${pillarSubCat} subCategoryCheckBox pillarSubSubCatCheckBox"
              id="pillar-master${subsubCatString}" />
          </div>
          <div id="pillars${subsubCatString}" class="pillarSubCatQuestionsContainer subCategoryQuestionsCont collapse-content vcollapse-content">
            <div class="content-container"></div>
          </div>
        </div>
        `
      );
    });
  });

  function mapPillarsQuestions() {
    data.pillarsQuestions.map(function (subCat) {
      var y = subCat.subsubCategories;
      y.map(function (q) {
        var questionList = q.questions;
        questionList.map(function (question) {
          var subsubCatString = question.SubSubID.replace(/\./g, "").toString();

          $(`#pillars${subsubCatString} .content-container`).append(
            `<div class="pillars-question-item questionItem">
              <label for="${question.QuestionID}">${question.QuestionID} ${question.Question}</label>
              <input type="checkbox" class="pillarsQuestionItem${subsubCatString} questionCheckBox pillarsQuestionItemCheckbox"
                id="${question.QuestionID}"
                value="${question.Question}"
                data-parentsubCat="${question.subSubCategory}" data-Over="${question.overArching}">
            </div>`
          );
        });
      });
    });
  }
  mapPillarsQuestions();
  /********************END TEMPLATING********************/
  /*******************CHECKBOX BEHAVIOR*******************/
  //checks all boxes, takes two arguments: targetBoxes, and Boolean to determine whether they should be checked or unchecked
  function check(targets, boolean) {
    var targets = $(targets);
    for (var i = 0; i < targets.length; i++) {
      targets[i].checked = boolean;
    }
    // Triggers 'change' event, other wise final else statement in checkbawks change wouldn't do anything if checkboxes are dynamically changed
    targets.trigger("change");
  }

  //Sorts Results questions into numerical Order
  function organizeReportQuestions(container) {
    var cont = $(`#result--lc-${container} .localQuestionnaireQuestionGroup`);
    var arr = $.makeArray(cont.children(`.group${container}`));
    arr.sort(function (a, b) {
      var textA = +$(a).find(".resultQuestionText").data("question-number");
      var textB = +$(b).find(".resultQuestionText").data("question-number");
      if (textA > textB) return 1;
      if (textA < textB) return -1;
      return 0;
    });
    cont.empty();
    cont.closest(`#result--lc-${container}`).hide();
    cont.closest(`#result--lc-${container}`).find(".CategoryHeading").remove();

    $.each(arr, function () {
      cont.append(this);
    });
  }

  function addLocalSectionHeadings(container) {
    var section = $(`#result--lc-${container}`);

    if (section.find(`.group${container}`).length > 0) {
      section.show();
      const currentCat = data.localContext.find(
        (item) => item.subCat === container
      );

      section.prepend(
        `<div class="CategoryHeading">
          <div class="categoryQuestionnaireNumber">${currentCat.romanNum}</div>
          <div class="my-auto">
            <div class="categoryQuestionnaireLabel">${currentCat.subCategory}</div>
            <div class="overArchingQuestionnaireQuestion">${currentCat.overArching}</div>
          </div>
        </div>`
      );
    }
  }

  //Adds Question to their respective report
  function addToReport(div) {
    var eyedee = div.id;
    var number = eyedee.substring(1).replace(/\s/g, "");
    var container = eyedee.slice(0, 1);
    var questionItem = `<div class="group${container} ${div.classList[3]}" name="${eyedee}">
      <div class="resultQuestionText" for="${div.id}" data-question-number="${number}">${number}. ${div.value}</div>
    </div>`;

    $(`#result--lc-${container} .localQuestionnaireQuestionGroup`).append(
      questionItem
    );
    organizeReportQuestions(container);
    addLocalSectionHeadings(container);
  }

  //Remove Questions to their respective report
  function removeFromReport(div) {
    var eyedee = div.id;
    var container = eyedee.slice(0, 1);
    $(`#result--lc-${container} .localQuestionnaireQuestionGroup`)
      .find(`div[name="${eyedee}"]`)
      .remove();
    organizeReportQuestions(container);
    addLocalSectionHeadings(container);
  }

  //Finds all checkboxes
  var localContextCheckboxes = $('input[type="checkbox"].qCheckbox');
  //Map all checkboxes belonging to Local Context Categories
  const localQuestions = {
    lcCat1: $('input[type="checkbox"].A'),
    lcCat2: $('input[type="checkbox"].B'),
    lcCat3: $('input[type="checkbox"].C'),
  };

  // handles Click functions on localContext Boxes
  localContextCheckboxes.on("change", function () {
    const localCatKeys = Object.keys(localQuestions);
    if (localCatKeys.includes(this.id)) {
      const currentLocQuestion = localQuestions[this.id];
      $(this)[0].checked
        ? check(currentLocQuestion, true)
        : check(currentLocQuestion, false);
    } else {
      $(this)[0].checked ? addToReport(this) : removeFromReport(this);
    }
  });

  // local context - highlight selected questions on change
  $(".qCheckbox.question").on("change", function () {
    const questionItem = $(this).closest(".questionItem");
    if (this.checked === true) {
      questionItem.addClass("selected");
    } else {
      questionItem.removeClass("selected");
    }
  });

  $(".pillarCheckbox").on("change", function () {
    const tabTarget = $(this)
      .closest(".pillarsMainCategoryToggle")
      .data("target");
    const childTarget = $(tabTarget).find(
      ".pillars-subcategory-tab-content-container"
    );
    const x = childTarget.find(".subCategoryCheckBox");

    if (this.checked === true) {
      check(x, true);
    } else {
      check(x, false);
    }
  });

  $(".pillarSubSubCatCheckBox").on("change", function () {
    var pillarSubCatQuestionsContainerId = $(this)
      .closest(".subcategory-toggle-container")
      .find(".subcategory-toggle")
      .data("target");
    var targets = $(pillarSubCatQuestionsContainerId).find(
      'input[type="checkbox"]'
    );
    if (this.checked === true) {
      check(targets, true);
      $(this).closest(".subCategoryItem").addClass("selected");
    } else {
      check(targets, false);
      $(this).closest(".subCategoryItem").removeClass("selected");
    }
  });

  $(".pillarsQuestionItemCheckbox").on("change", function () {
    var number = this.id;
    var numberText = number.replace(/\./g, "");
    var questionValue = this.value;
    var pillar = this.id.slice(0, 1).toString(); // 1
    var subCategory = this.id.slice(0, 3).toString(); // 1.1
    var subCatString = subCategory.replace(/\./g, "");
    var parentCategory = $(this)[0].attributes[4].textContent;
    var overArch = $(this)[0].attributes[5].textContent;
    var targetDIV = $(`#result--pillars-${pillar}`);
    // var targetForQuestion = $(`#pillarsQuestionsTarget${subCategory}`);

    if (this.checked === true) {
      $(this).closest(".questionItem").addClass("selected");
    } else {
      $(this).closest(".questionItem").removeClass("selected");
    }

    const pillarData = data.pillarsQuestions.find(
      (item) => item.subCat.toString() === pillar
    );

    const pillarHeading = (pillarNumber) => {
      return `<div class="pillarSection" id="pillars${pillarNumber}">
        <div class="CategoryHeading">
          <div class="categoryQuestionnaireNumber">${pillarNumber}</div>
          <div class="categoryQuestionnaireLabel">${pillarData?.subCategory}</div>
        </div>
      </div>`;
    };

    const subsubCat = `<div data-subCatID="${subCatString}" id="subCategory${subCatString}" class="pillarSubCatSection">
      <div class="pillarSubCatHeading subCategoryQuestionnaireLabel">
        <div class="pillarsSubCategoryTitle subCategoryQuestionnaireLabelText">${subCategory} ${parentCategory}</div>
        <div class="pillarsOverArchingQuestionQuestionnaire overArchingQuestionnaireQuestion"><span>Overarching Question: </span> ${overArch}</div>
      </div>
    </div>`;

    const question = `<div id="${numberText}" class="localQuestionnaireQuestion ${subCategory}">
      <div>${number} ${questionValue}</div>
    </div>`;

    if (this.checked === true && targetDIV.find("div").length === 0) {
      // have not append yet
      if (targetDIV.find(`#pillars${pillar}`).length === 0) {
        // pillar heading
        targetDIV.append(pillarHeading(pillar));
        targetDIV.append(subsubCat);
        $(`div[data-subCatID="${subCatString}"]`).append(question);
      }
    } else if (
      this.checked === true &&
      targetDIV.find(`div[data-subCatID="${subCatString}"]`).length > 0
    ) {
      // have append
      if (targetDIV.find(`#pillars${pillar}`).length > 0) {
        $(`div[data-subCatID="${subCatString}"]`).append(question);
      }
    } else if (
      this.checked === true &&
      targetDIV.find(`#subCategory${subCatString}`).length === 0
    ) {
      // have not append yet
      if (targetDIV.find(`#pillars${pillar}`).length > 0) {
        targetDIV.append(subsubCat);
        $(`div[data-subCatID="${subCatString}"]`).append(question);
      }
    } else if (this.checked === false) {
      var key = `subCategory${subCatString}`;
      var orphanarium = targetDIV[0].children;
      $(`div#${numberText}`).remove();

      for (var i = 0; i < orphanarium.length; i++) {
        if (orphanarium[i].id === key) {
          if (orphanarium[i].childNodes.length === 1) {
            orphanarium[i].remove();
          }
        }
      }

      targetDIV.find(".pillarSubCatSection").each(function () {
        if ($(this).find(".localQuestionnaireQuestion").length === 0) {
          $(this).remove();
        }
      });

      if (targetDIV.find(".localQuestionnaireQuestion").length === 0) {
        targetDIV.empty();
        targetDIV.hide();
      }
    }

    // sort the selected questions into numerical order
    sortPillarsQuestions(targetDIV);

    if (targetDIV.find(".localQuestionnaireQuestion").length > 0) {
      targetDIV.show();
    } else {
      targetDIV.hide();
    }
  });

  function sortPillarsQuestions(container) {
    var cont = container;
    var arr = $.makeArray(cont.children(".pillarSubCatSection"));
    arr.sort(function (a, b) {
      var textA = +$(a).data("subcatid");
      var textB = +$(b).data("subcatid");
      if (textA > textB) return 1;
      if (textA < textB) return -1;
      return 0;
    });
    cont.find(".pillarSubCatSection").remove();

    $.each(arr, function () {
      cont.append(this);
    });
  }

  /*Show Report / Hide questions */
  $("#createQuestionnaireBtn").on("click", function () {
    const pillarsResults = $("#pillarsResults");
    const localContextResults = $("#localContextResults");

    $("#questionnaireContainer").show();

    if (pillarsResults.find(".localQuestionnaireQuestion").length > 0) {
      pillarsResults.prepend(
        `<div class="result-group-heading">
        <h3 class="h3">${$(".question-group-title--pillars").text()}</h3>
      </div>`
      );
      pillarsResults.show();
    } else {
      pillarsResults.hide();
    }

    if (localContextResults.find(".localQuestionnaireQuestion").length > 0) {
      localContextResults.prepend(
        `<div class="result-group-heading">
        <h3 class="h3">${$(".question-group-title--localContext").text()}</h3>
        </div>`
      );
      localContextResults.show();
    } else {
      localContextResults.hide();
    }

    $("#SoLDQuestionsContainer").hide();
    $(this).hide();
  });

  $("#closeQuestionnaireBtn").on("click", function () {
    $("#questionnaireContainer").hide();
    $(".result-group-heading").remove();
    $("#SoLDQuestionsContainer").show();
    $("#createQuestionnaireBtn").css({
      display: "inline-block",
    });
  });

  /*******************END CHECKBOX BEHAVIOR*******************/
  /*******************FINALIZE*******************/
  $(".vcollapse-questionnaire").each(function (index) {
    $(this).vCollapse({
      onLoad: "none",
      any: true,
      speed: 300,
    });
  });
  /*******************END FINALIZE*******************/
});
